if (!customElements.get('wls-50-50')) {
    class WLS5050 extends HTMLElement {
        constructor() {
            super();
    
            this.classes = {
                active: 'active',
                videoWrapper: 'wls-50-50__video',
            };
    
            this.elements = {
                videoWrapper: this.querySelector(`.${this.classes.videoWrapper}`),
                video: this.querySelector(`.${this.classes.videoWrapper} video`),
            };
        }
    
        /**
         * Lifecycle method called when the element is added to the DOM.
         * Adds a click event listener to the element.
         */
        connectedCallback() {
            this.handleVideoClick();
        }
    
        /**
         * Lifecycle method called when the element is removed from the DOM.
         * Removes the click event listener to clean up resources.
         */
        disconnectedCallback() {
            this.elements.videoWrapper?.removeEventListener('click', this.handleVideoClick);
        }
    
        /**
         * Handles click events on the video wrapper.
         * Toggles the video play/pause state and updates the active class.
         */
        handleVideoClick() {
            if (!this.elements.videoWrapper || !this.elements.video) return;
    
            this.elements.videoWrapper.addEventListener('click', () => {
                if (this.elements.video.paused) {
                    this.elements.video.play();
                    this.elements.videoWrapper.classList.add(this.classes.active);
                } else {
                    this.elements.video.pause();
                    this.elements.videoWrapper.classList.remove(this.classes.active);
                }
            });
        }
    }
    
    customElements.define('wls-50-50', WLS5050);
}
